import { XmlCursorPos, XMLCursorPositions } from '../cursor/xmlCursorPos.class';
import { Xml2html } from '../xml-html-converter/xml2html.class';

export class XmlEditRuleCheckElements {
  constructor(private xsdNodes: Map<string, Element>) {}

  ElementsAllowedAtThisCursorPos(cursorPosToCheck: XmlCursorPos): string[] {
    if (!cursorPosToCheck) {
      return [];
    }
    const parentNode = this.getRelevantParentNodeForCursorPos(cursorPosToCheck);
    const parentName = Xml2html.getTagNameFromNode(parentNode);
    const xsdNode = this.xsdNodes.get(parentName);
    if (xsdNode) {
      const result = this.getSubElementNames(xsdNode, []);
      return result;
    } else {
      // console.warn('element "' + parentName + '" not found');
      return [];
    }
  }

  getRelevantParentNodeForCursorPos(cursorPosToCheck: XmlCursorPos): Node {
    if (cursorPosToCheck) {
      let parentNode = cursorPosToCheck.ActualNode;

      switch (parentNode.nodeType) {
        case Node.COMMENT_NODE:
        case Node.TEXT_NODE:
          parentNode = parentNode.parentElement;
          break;

        case Node.ELEMENT_NODE:
          switch (cursorPosToCheck.PosAtNode) {
            case XMLCursorPositions.CursorInEmptyNode:
            case XMLCursorPositions.CursorInsideTextNode:
              break;

            case XMLCursorPositions.CursorBehindNode:
            case XMLCursorPositions.CursorInFrontOfNode:
            case XMLCursorPositions.CursorOnCompleteNode:
              parentNode = parentNode.parentElement;
              break;

            default:
              throw new Error(`unhandled  cursorPosToCheck.PosAmNode "${cursorPosToCheck.PosAtNode}"/${XmlCursorPos.getXmlCursorPositionDebugName(cursorPosToCheck.PosAtNode)}" `);
          }
          break;

        default:
          throw new Error(`unhandled  parentNode.nodeType "${parentNode.nodeType}"`);
      }
      return parentNode;
    }
  }

  public getSubElementNames(xsdNode: Node, alreadyAddedElementNames: string[], depth: number = 0): string[] {
    let elementNames: string[] = [];
    let elementName: string;

    if (xsdNode.nodeType === Node.ELEMENT_NODE) {
      const asElem = xsdNode as Element;
      if (asElem) {
        if (asElem.localName === 'element') {
          elementName = asElem.getAttribute('name');
        }
      }
    }

    if (elementName) {
      // console.warn('found: ' + JSON.stringify(elementName) + ' depth: ' + depth);
      if (alreadyAddedElementNames.length !== 0) {
        if (alreadyAddedElementNames.indexOf(elementName) !== -1) {
          return elementNames; // element recursion detected
        }
        if (depth === 0) {
          // is the parent element itself - skip!
        } else {
          elementNames = elementNames.concat(elementName);
          return elementNames;
        }
      }
      alreadyAddedElementNames.push(elementName);
    }

    const childNodes = Array.prototype.slice.call(xsdNode.childNodes) as Node[];

    depth++;

    childNodes.forEach(child => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        const childElem = child as Element;
        if (childElem) {
          switch (childElem.localName) {
            case 'complexType':
            case 'sequence':
            case 'choice':
            case 'simpleContent':
            case 'extension':
              elementNames = elementNames.concat(this.getSubElementNames(child, alreadyAddedElementNames, depth));
              break;

            case 'element':
              const refname = childElem.attributes.getNamedItem('ref');
              if (refname) {
                const referedNode = this.xsdNodes.get(refname.value);
                if (referedNode) {
                  elementNames = elementNames.concat(this.getSubElementNames(referedNode, alreadyAddedElementNames, depth));
                } else {
                  throw new Error(` refered element "${refname}" for element "${childElem.outerHTML}" not found`);
                }
              } else {
                elementNames = elementNames.concat(this.getSubElementNames(child, alreadyAddedElementNames, depth));
              }
              break;

            case 'attribute':
              break;

            default:
              throw new Error(`unknown childElem.localname "${childElem.localName}"/${childElem.outerHTML}`);
          }
        }
      }
    });

    return elementNames;
  }
}
